import type { ScoreUnit } from '../types';

import { schoolYearStartYear } from '../../../core/schoolYear';

export const EM_DASH = '—';

export function fmtLevel(value: number | null | undefined): string {
  return value == null ? EM_DASH : value.toFixed(1);
}

export function fmtScale(value: number | null | undefined): string {
  return value == null ? EM_DASH : String(Math.round(value));
}

export function fmtDelta(value: number | null | undefined, unit = ' levels'): string {
  if (value == null) return EM_DASH;
  const sign = value > 0 ? '+' : value < 0 ? '−' : '';
  return `${sign}${Math.abs(value).toFixed(1)}${unit}`;
}

export function fmtDeltaScale(value: number | null | undefined): string {
  if (value == null) return EM_DASH;
  const sign = value > 0 ? '+' : value < 0 ? '−' : '';
  return `${sign}${Math.abs(Math.round(value))} pts`;
}

export function fmtSigned(value: number): string {
  return `${value >= 0 ? '+' : '−'}${Math.abs(value)}`;
}

export function pct(part: number, whole: number): string {
  return whole > 0 ? `${Math.round((100 * part) / whole)}%` : EM_DASH;
}

export function countWithShare(part: number, whole: number): string {
  return part > 0 ? `${part} · ${pct(part, whole)}` : '0';
}

export function shortYear(label: string): string {
  const start = schoolYearStartYear(label);
  if (start == null) return label;
  return `’${String(start).slice(-2)}–${String(start + 1).slice(-2)}`;
}

export function fmtGrowthIn(unit: ScoreUnit, growth: number | null | undefined, scale: number | null | undefined): string {
  return unit === 'scale_score' ? fmtDeltaScale(scale) : fmtDelta(growth);
}

export const levelNoun = (unit: ScoreUnit): string => (unit === 'scale_score' ? 'scale score' : 'level');
export const growthNoun = (unit: ScoreUnit): string => (unit === 'scale_score' ? 'scale-score points' : 'proficiency levels');
